/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import _keys from 'lodash/keys';
import { linkedAdjustmentsShape } from '../../../../../common/components/proptypes/commonProptypes';
import { TOTALS_KEY } from '../../../../../common/engine/utilities/constants';
import Adjustment from '../Adjustment/Adjustment';
import {
  getAdjustmentIsToggledActive,
  getLinksForAdjustment,
} from './AdjustmentGroupHelpers';
import AdjustmentGroupSummary from './AdjustmentGroupSummary';

const AdjustmentGroupDetails = ({
  projectId,
  documentCode,
  contentId,
  contentVersionNumber,
  group,
  groupName,
  timePeriods,
  showTotalRow,
  totalOverrideValue,
  showToggles,
  adjustmentToggles,
  disableAllToggles,
  linkedAdjustments,
  isPublishMode,
  isEditMode,
  adjustmentOptions,
  targetDocumentOptions,
  selectedLinkedAdjustments,
  setFieldValue,
  showLinkedAdjustments,
  isClientView,
}) => {
  const adjustmentNamesInGroup = _keys(group).filter((g) => g !== TOTALS_KEY);

  return (
    <>
      {adjustmentNamesInGroup.map((adjustmentName, index) => {
        const isLastAdjustment = index === adjustmentNamesInGroup.length - 1;
        const isFinalRow = isLastAdjustment && !showTotalRow;

        const isAdjustmentToggledActive = getAdjustmentIsToggledActive(
          adjustmentToggles,
          groupName,
          adjustmentName
        );
        const isActive = disableAllToggles ? true : isAdjustmentToggledActive;
        const adjustment = group[adjustmentName];

        const adjustmentLinks = getLinksForAdjustment(
          groupName,
          adjustmentName,
          linkedAdjustments
        );

        return (
          <Adjustment
            projectId={projectId}
            key={adjustmentName}
            documentCode={documentCode}
            contentId={contentId}
            contentVersionNumber={contentVersionNumber}
            adjustmentType={groupName}
            adjustmentKey={adjustmentName}
            adjustment={adjustment[TOTALS_KEY]}
            timePeriods={timePeriods}
            isActive={isActive}
            adjustmentLinks={adjustmentLinks}
            showToggle={showToggles}
            disableToggle={disableAllToggles}
            isPublishMode={isPublishMode}
            isFinalRow={isFinalRow}
            isEditMode={isEditMode}
            adjustmentOptions={adjustmentOptions}
            targetDocumentOptions={targetDocumentOptions}
            selectedLinkedAdjustments={selectedLinkedAdjustments}
            setFieldValue={setFieldValue}
            showLinkedAdjustments={showLinkedAdjustments}
            isClientView={isClientView}
          />
        );
      })}

      {showTotalRow ? (
        <AdjustmentGroupSummary
          totals={group[TOTALS_KEY]}
          totalOverrideValue={totalOverrideValue}
          timePeriods={timePeriods}
          documentCode={documentCode}
          isPublishMode={isPublishMode}
        />
      ) : null}
    </>
  );
};

AdjustmentGroupDetails.propTypes = {
  projectId: PropTypes.string.isRequired,
  documentCode: PropTypes.string.isRequired,
  contentId: PropTypes.number.isRequired,
  contentVersionNumber: PropTypes.number.isRequired,
  group: PropTypes.object.isRequired,
  groupName: PropTypes.string.isRequired,
  timePeriods: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  showTotalRow: PropTypes.bool.isRequired,
  totalOverrideValue: PropTypes.string,
  showToggles: PropTypes.bool,
  adjustmentToggles: PropTypes.object.isRequired,
  disableAllToggles: PropTypes.bool.isRequired,
  linkedAdjustments: PropTypes.arrayOf(linkedAdjustmentsShape).isRequired,
  isPublishMode: PropTypes.bool,
};

AdjustmentGroupDetails.defaultProps = {
  totalOverrideValue: undefined,
  showToggles: true,
  isPublishMode: false,
};

export default AdjustmentGroupDetails;
